// extracted by mini-css-extract-plugin
module.exports = {"container":"Videos_container__2VGJh","confirm":"Videos_confirm__3HXh9"};